// extracted by mini-css-extract-plugin
export var deliveryRow = "_s7-a";
export var fixedHeight = "_s7-4";
export var freightLogo = "_s7-9";
export var fullWidth = "_s7-3";
export var priceColumn = "_s7-5";
export var radioSelected = "_s7-7";
export var radioUnselected = "_s7-6";
export var selectedOption = "_s7-2";
export var selectedOptionContainer = "_s7-1";
export var selection = "_s7-0";
export var tallSkeletonText = "_s7-8";